import { cva } from "class-variance-authority";

export const variants = {
  theme: {
    blue: "bg-primary-500",
    yellow: "bg-secondary-500",
    purple: "bg-purple-500",
    orange: "bg-orange-500",
    outline: "bg-white border border-primary-500",
    green: "bg-success-500",
    primary: "bg-primary-500",
  },
  text: {
    blue: "text-primary-500",
    yellow: "text-secondary-500",
    purple: "text-purple-500",
    orange: "text-orange-500",
    outline: "text-primary-500",
    green: "text-success-500",
    primary: "text-primary-500",
  },

  highlight: {
    blue: "bg-primary-100/40 border border-blue-500",
    yellow: "bg-secondary-100/40 border border-yellow-500",
    purple: "bg-purple-100/40 border border-purple-500",
    orange: "bg-orange-100/40 border border-orange-500",
    outline: "bg-white border border-primary-100",
    green: "bg-success-100/40 border border-green-500",
    primary: "bg-primary-100/40 border border-primary-500",
  },
};

export const pricingVariants = cva("", {
  variants,
});